import { render } from "./Error.vue?vue&type=template&id=26bc6465"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
script.render = render

export default script